import { render, staticRenderFns } from "./addProductTypeDrawer.vue?vue&type=template&id=62ff31e8&scoped=true&"
import script from "./addProductTypeDrawer.vue?vue&type=script&lang=js&"
export * from "./addProductTypeDrawer.vue?vue&type=script&lang=js&"
import style0 from "./addProductTypeDrawer.vue?vue&type=style&index=0&id=62ff31e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff31e8",
  null
  
)

export default component.exports